import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConsolidatedDetailModal = ({ show, onHide, consolidated }) => {
  if (!consolidated) return null;

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>consolidated Data Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Month/Year :</strong> {consolidated.month}/{consolidated.year}
        </p>
        <p>
          <strong>Direct Salary :</strong> {consolidated.salary?.direct || "-"}
        </p>
        <p>
          <strong>Indirect Salary :</strong>{" "}
          {consolidated.salary?.indirect || "-"}
        </p>

        <p>
          <strong>Direct Expense :</strong>{" "}
          {consolidated.expenses?.direct || "-"}
        </p>
        <p>
          <strong>Indirect Expense :</strong>{" "}
          {consolidated.expenses?.indirect || "-"}
        </p>
        <p>
          <strong>Damages :</strong> {consolidated.damages}
        </p>
        <p>
          <strong>Lease :</strong> {consolidated.lease}
        </p>
        <p>
          <strong>Total Amount :</strong> {consolidated.total}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConsolidatedDetailModal;
